<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
import config from '../../../../../configHttp';
import { cfqueryCf, getCombo, cfadjustManually } from '../../../../api/home.js';
export default {
	name: 'FileImport',
	components: {
		uploadFileplus
	},
	data() {
		return {
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('CustomImportTaskheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('CustomImportTaskoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			Count: 0,
			sort: '',
			order: '',
			/* 表格 */
			xmdm: []
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		handleCommand(value) {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
				return;
			}
			this.$showConfirm({
				message: '确认操作?'
			}).then(r => {
				if (r == 'confirm') {
					let params = {};
					params.ids = this.$refs.tablebox
						.getSelectionval()
						.map(v => v.id)
						.join(',');
					params.projectCode = value;
					cfadjustManually(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('调整成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('CustomImportTaskoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('CustomImportTaskheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			cfqueryCf(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						v.pingzrq = this.formatDate(v.pingzrq);
						v.guozrq = this.formatDate(v.guozrq);
						v.gengxsj = this.formatDate(v.gengxsj);
						return v;
					});

					this.pagination.total = res.data.count;
					let paramsqj = {};
					paramsqj.name = 'DIRECT_METHOD_PROJECT_NAME';
					getCombo(paramsqj).then(res => {
						if (res.data.code == '200') {
							this.xmdm = res.data.data.map(v => {
								return {
									label: v.value,
									value: v.key
								};
							});
						}
					});
					paramsqj.name = 'CF_DOCUMENT_TYPE';
					getCombo(paramsqj).then(res => {
						if (res.data.code == '200') {
							this.searchlist = getdata().searchlist;
							this.searchlist[5].selectval = res.data.data.map(v => {
								return {
									label: v.value,
									value: v.key
								};
							});
						}
					});
				}
			});
		},
		formatDate(value) {
			// 时间戳转换日期格式方法
			if (value == null) {
				return value;
			} else {
				const date = new Date(value);
				const y = date.getFullYear(); // 年
				let MM = date.getMonth() + 1; // 月
				MM = MM < 10 ? '0' + MM : MM;
				let d = date.getDate(); // 日
				d = d < 10 ? '0' + d : d;
				return y + '-' + MM + '-' + d;
			}
		},
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
